<template>
  <OwnerBusinessesView
    :is_loading="is_loading"
    :is_in_admin_view="true"
    @set-page-attributes="on_set_page_attributes"
  >
  </OwnerBusinessesView>
</template>

<script>
import OwnerBusinessesView from "./../../business_owner/businesses/OwnerBusinessesView";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminBusinessesView",
  components: {
    OwnerBusinessesView,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  methods: {
    on_set_page_attributes(attr) {
      this.$emit("set-page-attributes", attr);
    },
  },
};
</script>